module.exports = __webpack_public_path__ + "media/Screenrecorder-2021-10-27-15-57-14-27.7479a386.mp4";